module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Breakfast"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Breakfast ")])]), _c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('h2', {
    staticClass: "nodivide"
  }, [_c('a', {
    attrs: {
      "id": "d0e105",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Blueberry French Toast Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (20-ounce) loaf bread, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (8-ounce) package cream cheese, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup fresh or frozen blueberries ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/3 cups maple syrup ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Powdered sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maple or blueberry syrup ")])])])]), _vm._v(" "), _c('p', [_vm._v("Place half the bread cubes in a greased 9 x 13-inch pan. Layer cream cheese cubes\n                evenly over bread. Sprinkle blueberries over top. Cover with the remaining bread\n                cubes. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, whisk together the eggs, milk, vanilla, and syrup. Drizzle the egg\n                mixture evenly over bread. Cover and refrigerate 2 hours or overnight; remove 30\n                minutes prior to baking. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Let casserole come to room temperature, then cover with\n                aluminum foil and bake 30 minutes. Uncover and bake 25–30 minutes more, or until\n                center is firm and top is golden brown. Lightly dust casserole with the powdered\n                sugar. Serve with blueberry or maple syrup. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e108",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Raspberry French Toast Bake ")])]), _c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1/2 cup flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups whole milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 slices bread, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 ounces cream cheese, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup fresh or frozen raspberries (if using frozen, do not defrost!) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup chopped pecans ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Powdered sugar for garnish ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, whisk together the flour, milk, 2 tablespoons sugar, vanilla, and\n                eggs. Add the cubed bread to egg mixture. Pour into a greased 9 x 13-inch pan and\n                sprinkle the cream cheese and raspberries over top. Cover tightly and refrigerate\n                for up to 24 hours; remove 30 minutes prior to baking. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. In a small bowl, combine the pecans, 2 tablespoons\n                sugar, and cinnamon. Sprinkle over the casserole. Cover with aluminum foil and bake\n                30 minutes. Uncover and bake 25–30 minutes more, or until center is firm and top is\n                golden brown. Dust with powdered sugar before serving. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cinnamon Raisin French Toast\n                Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (24-ounce) loaf cinnamon raisin bread, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 eggs, slightly beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 teaspoons vanilla ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Powdered sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maple syrup ")])])])]), _vm._v(" "), _c('p', [_vm._v("Place bread cubes into a greased 9 x 13-inch pan. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, whisk together the eggs, milk, and vanilla. Pour egg mixture evenly over\n                bread. Cover and refrigerate 2 hours or overnight. Remove from refrigerator 20\n                minutes before baking. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Bake uncovered for 45–50 minutes, or until golden brown.\n                Sprinkle powdered sugar and drizzle with maple syrup. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Apple-Cranberry Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (21-ounce) can apple pie filling ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (14-ounce) can whole-berry cranberry sauce ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups rolled oats ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2/3 cup brown sugar ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon cinnamon ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("French toast or pancakes")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("Combine the pie filling and cranberry sauce in a 1-quart bowl. Spread the\n                apple-cranberry mixture into an 8 x 8-inch pan prepared with nonstick cooking spray. ")]), _vm._v(" "), _c('p', [_vm._v("In a separate bowl, use a fork to mix together the butter, oats, brown sugar, and\n                cinnamon until crumbly. Sprinkle evenly over top. Bake for 35–40 minutes, or until\n                golden brown and crisp. Serve over French toast or pancakes. ")]), _vm._v(" "), _c('p')]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e232",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Asparagus English Muffin Bake ")])]), _c('a', {
    attrs: {
      "id": "d0e232",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 pound fresh asparagus, cut into 1-inch pieces ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 English muffins, split and toasted ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups grated Colby Jack cheese, divided ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups diced fully cooked ham ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 1/2 cups chopped red bell pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon dry mustard ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons black pepper ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a 4-quart saucepan, boil the asparagus pieces for 1 minute; drain and put into a\n                large bowl of ice water to stop the cooking process. Remove and pat asparagus dry\n                with paper towels. ")]), _vm._v(" "), _c('p', [_vm._v("Place the English muffin halves cut side up to form a crust in the bottom of a\n                greased 9 x l3-inch pan. Cut the muffins to fill the empty spaces in the pan as\n                needed. Layer the asparagus, half the cheese, ham, and bell pepper over the muffins. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, whisk together the eggs, milk, salt, dry mustard, and pepper. Pour\n                the egg mixture evenly over ham and cheese layer. Cover and refrigerate 2 hours or\n                overnight. Remove from refrigerator 30 minutes before preheating the oven to 375\n                degrees. Bake for 40–45 minutes, or until set in the center. Immediately sprinkle\n                remaining cheese over top and serve. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e232",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Baked Breakfast Burritos ")])]), _c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("12 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup chunky salsa ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 medium flour tortillas ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (4-ounce) can chopped green chiles ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a frying pan, scramble the eggs and salsa together until firm but not dry. Heat\n                the tortillas in the microwave until softened. Put a spoonful of scrambled egg\n                mixture in the middle of each tortilla. Roll up tortillas and place in a greased 9 x\n                13-inch pan. Sprinkle with green chiles and cheese. Cover with aluminum foil and\n                bake 15 minutes. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("NOTE:")])]), _vm._v(" Cook and crumble spicy sausage into the scrambled eggs for a heartier\n                breakfast. ")]), _vm._v(" "), _c('p')]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e266",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e294",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Scrambled Egg and Ham Pizza ")])]), _c('a', {
    attrs: {
      "id": "d0e294",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (13.8-ounce) tube refrigerated pizza crust dough ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 tablespoons milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups diced fully cooked ham ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 400 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("Spread the pizza dough along the bottom and halfway up the sides of a greased 9 x\n                13-inch pan. Bake for 8 minutes. ")]), _vm._v(" "), _c('p', [_vm._v("In a frying pan, scramble and cook the eggs and milk until firm but not dry. Season\n                with salt and pepper. Spread scrambled eggs over the hot crust. Place ham and cheese\n                evenly over the eggs. Bake for 8–12 minutes, or until crust is golden brown and\n                cheese is melted. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e294",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e320",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ham and Cheese Breakfast Bake ")])]), _c('a', {
    attrs: {
      "id": "d0e320",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("12 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups diced fully cooked ham ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup chopped green onion ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2/3 cup chopped green bell pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups grated medium or sharp cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a 2-quart bowl, whisk together the eggs until smooth; mix in the milk and pepper.\n                Stir in the ham, green onion, bell pepper, and half the cheese. Pour the egg mixture\n                into a 9 x 13-inch pan prepared with nonstick cooking spray. Bake for 45 minutes.\n                Sprinkle remaining cheese over top and bake for 5–15 minutes more, or until center\n                is set. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("NOTE:")])]), _vm._v(" If you prefer, omit the onion and bell pepper and increase the amount of ham\n                to 3 cups. ")]), _vm._v(" "), _c('p')]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e320",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e352",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Eggs for Everybody ")])]), _c('a', {
    attrs: {
      "id": "d0e352",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("12 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated Monterey Jack cheese, divided ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound bacon cooked and crumbled ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 bunch green onions, chopped ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 325 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, beat together the eggs, milk, and half the cheese. Stir in the bacon and\n                green onions. Pour mixture into a greased 9 x 13-inch pan. Cover with aluminum foil\n                and bake for 45–55 minutes, or until eggs are set. Immediately top with remaining\n                cheese and serve. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e352",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Southwestern Eggs ")])]), _c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("12 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 (4-ounce) cans chopped green chiles ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup chopped red bell pepper ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated Monterey Jack cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, beat together the eggs and milk; set aside. ")]), _vm._v(" "), _c('p', [_vm._v("In a greased 9 x 13-inch pan, layer the chiles, bell pepper, and cheeses. Pour the\n                egg mixture over top. Cover with aluminum foil and bake for 30–40 minutes, or until\n                eggs are set in the center. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e374",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e400",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Omelet Brunch ")])]), _c('a', {
    attrs: {
      "id": "d0e400",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("18 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup sour cream ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup chopped green onions ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 325 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, beat together the eggs, sour cream, milk, and salt. Fold in the\n                green onions. Pour egg mixture into a greased 9 x 13-inch pan. Bake for 45–55\n                minutes, or until eggs are set. Immediately sprinkle cheese over top and cut into\n                squares before serving. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e400",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e424",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Spinach Frittata ")])]), _c('a', {
    attrs: {
      "id": "d0e424",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 2–4 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4 large eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (10-ounce) package frozen spinach, thawed and drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup grated cheddar or Swiss cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 400 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, beat together the eggs, milk, and salt. Pour egg mixture into a greased 8\n                x 8-inch pan. Spread the spinach over top. Bake for 17–22 minutes, or until eggs\n                have set. Sprinkle cheese over top and serve. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e424",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e446",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Green Chile Breakfast Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e446",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("10 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup cottage cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup butter ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup flour ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups grated Colby Jack cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon baking powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon garlic powder ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 (4-ounce) cans chopped green chiles ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound breakfast sausage, browned, and drained ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, whisk together the eggs. Add all remaining ingredients in the order\n                listed, mixing well. Bake for about 1 hour, or until the edges are browned and a\n                knife inserted in the center comes out clean. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e446",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e478",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sausage–Hash Brown Breakfast Bake ")])]), _c('a', {
    attrs: {
      "id": "d0e478",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("3-1/2 cups frozen shredded hash browns ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound sausage, browned and drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon dry mustard ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 teaspoons black pepper ")])])])]), _vm._v(" "), _c('p', [_vm._v("Spread the hash browns into the bottom of a greased 9 x 13-inch pan. Sprinkle cooked\n                sausage and cheese over top. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, combine the eggs, milk, dry mustard, salt, and pepper. Pour egg mixture\n                evenly over sausage and hash browns. Cover and refrigerate 2 hours or overnight.\n                Remove from refrigerator 20 minutes before baking. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Cover with aluminum foil and bake for 30 minutes.\n                Uncover and bake for 5–8 minutes more, or until center is set. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e478",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e508",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Crescent, Hash Brown, and Sausage\n                Bake ")])]), _c('a', {
    attrs: {
      "id": "d0e508",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 4–6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 (8-ounce) tube refrigerated crescent roll dough ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (10.4-ounce) package sausage links, browned, drained, and sliced ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup frozen hash browns ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/3 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fresh salsa ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 375 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("Unroll the crescents and press dough over bottom and up the sides of a 12-inch round\n                pizza pan. (Dough up the sides of the pan should have a small lip so when the egg\n                mixture is added, it stays in the crust.) Sprinkle the sausage, hash browns, and\n                cheese over dough. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, beat together the eggs, milk, salt, and pepper with a fork. Pour egg\n                mixture over dough. Bake for 30 minutes. Serve wedges with fresh salsa. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e508",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e538",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Swiss Sausage Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e538",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("10 slices white bread, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound spicy sausage, browned and drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (4-ounce) can sliced mushrooms, drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3/4 cup grated cheddar cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups grated Swiss cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("8 eggs, beaten ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups half-and-half ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 teaspoon black pepper ")])])])]), _vm._v(" "), _c('p', [_vm._v("Place the bread cubes in a greased 9 x 13-inch pan. Crumble the sausage over bread.\n                Evenly lay mushrooms over sausage and sprinkle cheeses over top. ")]), _vm._v(" "), _c('p', [_vm._v("In a large bowl, mix together the eggs, half-and-half, milk, salt, and pepper. Pour\n                egg mixture evenly over cheese. Cover and refrigerate 2 hours or overnight. Remove\n                from refrigerator 20 minutes before baking. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Cover with aluminum foil and bake for 30 minutes.\n                Uncover and bake for 15–20 minutes more. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e538",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e572",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Creamy Breakfast Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e572",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("10 slices bread, crust removed, cubed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 pound sausage, browned and drained ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups grated sharp cheddar cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 large eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon yellow mustard ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 cups milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 (10.75-ounce) can cream of mushroom soup ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])])])]), _vm._v(" "), _c('p', [_vm._v("In a greased 9 x 13-inch baking dish, place the bread topped with the sausage and\n                cheese. ")]), _vm._v(" "), _c('p', [_vm._v("In a bowl, whisk together the eggs, mustard, and 2 cups milk. Pour egg mixture over\n                sausage. Cover and refrigerate overnight. ")]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. Mix together the soup and 1/2 cup milk. Pour over bread\n                mixture. Bake for 45 minutes. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e572",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e602",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sausage Breakfast Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e602",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 4–6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1/2 pound sausage ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon thyme ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups frozen shredded hash browns, thawed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 medium eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 tablespoon dried minced onion ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated cheddar cheese ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 400 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("Brown and drain sausage in a frying pan. Add the thyme and hash browns and set aside. ")]), _vm._v(" "), _c('p', [_vm._v("In a mixing bowl, whisk together the eggs, milk, onion, salt, and pepper. Stir in the\n                sausage mixture and cheese. Pour into a greased 8 x 8-inch pan. Bake for 30–35\n                minutes, or until center is set and casserole has turned golden brown. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e602",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e632",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sausage Grits Casserole ")])]), _c('a', {
    attrs: {
      "id": "d0e632",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 6–8 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1 pound ground Italian pork sausage ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup chopped onion ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon minced garlic ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 cups water ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 teaspoon salt ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup quick-cooking grits ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/4 cup butter, softened ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 large eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-1/2 cups grated cheddar cheese, divided ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 350 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a large skillet, brown the sausage, onion, and garlic until sausage is crumbly and\n                no longer pink; drain if necessary. ")]), _vm._v(" "), _c('p', [_vm._v("In a 3-quart saucepan, bring the water and salt to a boil. Slowly stir in the grits.\n                Reduce heat and simmer for 4–5 minutes, stirring constantly. Remove grits from heat\n                stir in milk and butter until butter melts. ")]), _vm._v(" "), _c('p', [_vm._v("In a 1-quart bowl, whisk the eggs until lightly beaten. Stir a spoonful of hot grits\n                into the eggs. Quickly stir egg mixture into hot grits until eggs are completely\n                combined. Stir in sausage mixture and 1 cup cheese. Pour grits mixture into a 9 x\n                13-inch pan prepared with nonstick cooking spray. Bake uncovered for 45 minutes.\n                Sprinkle remaining cheese over top. Bake an additional 5–10 minutes. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e632",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e668",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Simple Bacon Breakfast Pie ")])]), _c('a', {
    attrs: {
      "id": "d0e668",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Makes 4–6 servings. ")])])]), _vm._v(" "), _c('table', {
    staticClass: "simplelist",
    attrs: {
      "border": "0",
      "summary": "Simple list"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("6 medium eggs ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/2 cup milk ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Salt and pepper, to taste ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 cups frozen shredded hash browns, thawed ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 cup grated Swiss cheese ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1/3 cup real bacon bits ")])])])]), _vm._v(" "), _c('p', [_vm._v("Preheat oven to 400 degrees. ")]), _vm._v(" "), _c('p', [_vm._v("In a 2-quart mixing bowl, whisk together the eggs, milk, salt, and pepper. Stir in\n                the hash browns, cheese, and bacon. Pour mixture into a greased 8 x 8-inch pan. Bake\n                for 30–35 minutes, or until center is set and pie has turned golden brown. ")])])]), _c('a', {
    attrs: {
      "id": "d0e668",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef27399","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 69
// module chunks = 0